import {types} from 'mediasoup-client'

export function startRecordingMessage() {
  return {
    method: 'sfu:startRecording',
    params: {},
  }
}

export function stopRecordingMessage() {
  return {
    method: 'sfu:stopRecording',
    params: {},
  }
}

export function syncRecordingMessage(transportId: string, producerId: string) {
  return {
    method: 'sfu:syncRecording',
    params: {
      transportId,
      producerId,
    },
  }
}

export function createTransportMessage() {
  return {
    method: 'sfu:createTransport',
    params: {},
  }
}

export function connectTransportMessage(transportId: string, dtlsParameters: types.DtlsParameters) {
  return {
    method: 'sfu:connectTransport',
    params: {
      transportId: transportId,
      dtlsParameters: dtlsParameters,
    },
  }
}

export function produceMessage(
  transportId: string,
  kind: types.MediaKind,
  rtpParameters: types.RtpParameters,
  source: string,
  trackId: string
) {
  return {
    method: 'sfu:produce',
    params: {
      transportId,
      kind,
      rtpParameters,
      source,
      trackId,
    },
  }
}

export function produceDataMessage(
  transportId: string,
  sctpStreamParameters: types.SctpStreamParameters,
  appData: types.AppData,
  label?: string,
  protocol?: string
) {
  return {
    method: 'sfu:produceData',
    params: {
      transportId,
      sctpStreamParameters,
      label,
      protocol,
      appData,
    },
  }
}

export function resumeConsumerMessage(transportId: string, consumerId: string) {
  return {
    method: 'sfu:resumeConsumer',
    params: {
      transportId: transportId,
      consumerId: consumerId,
    },
  }
}

export function closeProducerMessage(transportId: string, producerId: string) {
  return {
    method: 'sfu:closeProducer',
    params: {
      transportId: transportId,
      producerId: producerId,
    },
  }
}

export function getRouterRtpCapabilitiesMessage() {
  return {
    method: 'sfu:getRouterRtpCapabilities',
    params: {},
  }
}

export function leaveRoomMessage(options) {
  return {
    method: 'sfu:leaveRoom',
    params: {
      peerId: options.peerId,
    },
  }
}

export function consumeMessage(producerId: string, transportId: string, rtpCapabilities: types.RtpCapabilities) {
  return {
    method: 'sfu:consume',
    params: {
      producerId,
      transportId,
      rtpCapabilities,
    },
  }
}

export function consumeDataMessage(dataProducerId: string, transportId: string) {
  return {
    method: 'sfu:consumeData',
    params: {
      dataProducerId,
      transportId,
    },
  }
}
